import React, { useEffect, useState } from 'react';
import "../../assets/styles/Profile.css";
import Popup from "reactjs-popup";
import { motion } from "framer-motion";
import Header from "../../components/Header.js";
import HtmlNote from "../../components/Profile/HtmlNote.js";
import imgBtnUser from "../../imgs/bt-change-name.png";
import imgBtnUserHover from "../../imgs/bt-change-name-hover.png";
import imgBtnPhone from "../../imgs/bt-change-phone.png";
import imgBtnPhoneHover from "../../imgs/bt-change-phone-hover.png";
import imgBtnMail from "../../imgs/bt-change-mail.png";
import imgBtnMailHover from "../../imgs/bt-change-mail-hover.png";
import imgBtnBank from "../../imgs/bt-change-bank.png";
import imgBtnBankHover from "../../imgs/bt-change-bank-hover.png";
import imgBtnPassLogin from "../../imgs/btn-change-pass-login.png";
import imgBtnPassLoginHover from "../../imgs/btn-change-pass-login.png";
import imgBtnPassWithdraw from "../../imgs/btn-change-pass-withdraw.png";
import imgBtnPassWithdrawHover from "../../imgs/btn-change-pass-withdraw.png";

import imgBottom from "../../imgs/img-bottom-cskh.png";
import iconClose from "../../icons/icon-close.png";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { apiGetRequestHistory } from "../../services/api.service.js";
import { requestStatusText, requestTypeText, getVerificationStatusText, maskRequestCode } from "../../utils/requestHistory.js";


function Profile() {
  const location = useLocation();
  const { userName, data, webSetting } = location.state || {};
  const navigate = useNavigate();
  const [requestCode, setRequestCode] = useState("");
  const [requestHistory, setRequestHistory] = useState(null);
  const [requestHistoryError, setRequestHistoryError] = useState("");
  const [openRequestHistoryResult, setOpenRequestHistoryResult] = useState(false);
  const [showRequestHistoryHelp, setShowRequestHistoryHelp] = useState(false);
  const [recentRequests, setRecentRequests] = useState((data?.recent_requests || []).slice(0, 2));

  useEffect(() => {
    setRecentRequests((data?.recent_requests || []).slice(0, 2));
  }, [data?.recent_requests]);

  const shouldNavigate =(!userName || userName === "undefined");
  useEffect(() => {
    if (shouldNavigate) {
      navigate('/');
    }
  }, [navigate, shouldNavigate]);

  if (!shouldNavigate) {
    const changeInfo = async (typeModal) => {
      if (!userName) {
        return Swal.fire({ icon: "error", text: "Vui lòng nhập tên tài khoản." });
      } else {
        navigate("/change-info",{ state: { userName, data: { ...data, recent_requests: recentRequests }, webSetting, typeModal } });
      }
    };

    const checkRequestHistory = async () => {
      const code = requestCode.trim();
      setRequestHistoryError("");
      if (!/^\d{8}$/.test(code)) {
        setRequestHistoryError("Vui lòng nhập đúng mã yêu cầu gồm 8 số.");
        return;
      }
      const result = await apiGetRequestHistory(userName, code);
      if (result?.code === 200 && result?.data?.request) {
        setRequestHistory(result.data.request);
        setOpenRequestHistoryResult(true);
      } else {
        setRequestHistoryError(result?.message || "Không tìm thấy yêu cầu.");
      }
    };

    return (
      <div className="container">
        <motion.div className="app">
          <Header isPageSearch={false} webSetting={webSetting}/>
          <div className="content">
            <div className="profile">
              <div className="request-history">
                <div className="request-history-heading">
                  <span className="profile-titlte title-btn-change">LỊCH SỬ YÊU CẦU&nbsp;
                    <span className="request-history-help" onMouseEnter={() => setShowRequestHistoryHelp(true)} onMouseLeave={() => setShowRequestHistoryHelp(false)}>
                      <button type="button" className="request-history-help-icon" aria-label="Thông tin lịch sử yêu cầu" onClick={() => setShowRequestHistoryHelp((value) => !value)}>!</button>
                      {showRequestHistoryHelp && <div className="request-history-help-content">Danh sách chỉ hiển thị tối đa 2 yêu cầu gần nhất trong 48 giờ. Nhập mã yêu cầu 8 số để xem chi tiết kết quả xử lý.</div>}
                    </span>
                  </span>
                </div>
                {recentRequests.length > 0 && <div className="recent-requests">
                  {recentRequests.map((request, index) => <div className={`recent-request-item status-${request.status}`} key={`${request._request_code || request.request_code}-${index}`}>
                    <div className="recent-request-main"><strong>{requestTypeText[request.update_type] || request.update_type}</strong><span className="recent-request-code">{maskRequestCode(request.request_code)}</span></div>
                    <div className="recent-request-meta">
                      <span className={`recent-request-status status-${request.status}`}>{requestStatusText[request.status] || request.status}</span>
                      {request.status === "no_process" && ["email", "phone_number"].includes(request.send_type) && <span className={`verification-status verification-${request.verification_status || "not_received"}`}>{getVerificationStatusText(request.verification_status || "not_received", request.send_type)}</span>}
                    </div>
                  </div>)}
                </div>}
                <div className="request-history-form">
                  <input type="text" inputMode="numeric" maxLength="8" value={requestCode} onChange={(event) => { setRequestCode(event.target.value.replace(/\D/g, "")); setRequestHistoryError(""); }} onKeyDown={(event) => event.key === "Enter" && checkRequestHistory()} placeholder="Nhập mã yêu cầu 8 số" />
                  <button type="button" onClick={checkRequestHistory}>Kiểm tra</button>
                </div>
                {requestHistoryError && <p className="request-history-error">{requestHistoryError}</p>}
              </div>
              <span className="profile-titlte title-btn-change">THAY ĐỔI MỤC THÔNG TIN MỚI</span>
              <div className="action">
                <div className="action-btn" onClick={() => changeInfo("full_name")}>
                  <img className="img-default" src={imgBtnUser} alt="icon-user" />
                  <img className="img-hover" src={imgBtnUserHover} alt="icon-user" />
                </div>
                <div className="action-btn" onClick={() => changeInfo("phone_number")}>
                  <img className="img-default" src={imgBtnPhone} alt="icon-phone" />
                  <img className="img-hover" src={imgBtnPhoneHover} alt="icon-user" />
                </div>
              </div>
              <div className="action">
                <div className="action-btn" onClick={() => changeInfo("email")}>
                  <img className="img-default" src={imgBtnMail} alt="icon-mail" />
                  <img className="img-hover" src={imgBtnMailHover} alt="icon-mail" />
                </div>
                <div className="action-btn" onClick={() => changeInfo("bank")}>
                  <img className="img-default" src={imgBtnBank} alt="icon-bank" />
                  <img className="img-hover" src={imgBtnBankHover} alt="icon-bank" />
                </div>
              </div>
              <div className="action">
                <div className="action-btn" onClick={() => changeInfo("forget_password")}>
                  <img className="img-default" src={imgBtnPassLogin} alt="icon-pass-login" />
                  <img className="img-hover" src={imgBtnPassLoginHover} alt="icon-pass-login" />
                </div>
                <div className="action-btn" onClick={() => changeInfo("forget_password_withdraw")}>
                  <img className="img-default" src={imgBtnPassWithdraw} alt="icon-pass-withdraw" />
                  <img className="img-hover" src={imgBtnPassWithdrawHover} alt="icon-pass-withdraw" />
                </div>
              </div>
              <div>
                <img className="img-bottom img-bottom-profile" alt="bottom" src={imgBottom} />
              </div>
            </div>
            <Popup
              open={openRequestHistoryResult}
              onClose={() => setOpenRequestHistoryResult(false)}
              position="center"
              closeOnDocumentClick
              overlayStyle={{ display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0, 0, 0, 0.35)" }}
              contentStyle={{ position: "relative", inset: "auto", width: "auto", padding: 0, border: "none", background: "transparent" }}
            >
              <div className="request-history-modal">
                <button className="request-history-modal-close" onClick={() => setOpenRequestHistoryResult(false)}><img src={iconClose} alt="Đóng" /></button>
                {requestHistory && <div className={`request-history-result status-${requestHistory.status}`}>
                  <h3>KẾT QUẢ YÊU CẦU</h3>
                  <p><strong>Loại yêu cầu:</strong> {requestTypeText[requestHistory.update_type] || requestHistory.update_type}</p>
                  {requestHistory.data_update?.content && <p><strong>Nội dung yêu cầu:</strong> {requestHistory.data_update.content}</p>}
                  <p><strong>Trạng thái:</strong> {requestStatusText[requestHistory.status] || requestHistory.status}</p>
                  {requestHistory.status === "no_process" && ["email", "phone_number"].includes(requestHistory.send_type) && <p className={`verification-status verification-${requestHistory.verification_status || "not_received"}`}>{getVerificationStatusText(requestHistory.verification_status || "not_received", requestHistory.send_type)}</p>}
                  {(requestHistory.note || requestHistory.result) && <div className="request-result-note"><strong>Ghi chú/Kết quả:</strong><HtmlNote html={requestHistory.note || requestHistory.result} /></div>}
                  {requestHistory.createdAt && <p><strong>Ngày gửi:</strong> {new Date(requestHistory.createdAt).toLocaleString("vi-VN")}</p>}
                </div>}
              </div>
            </Popup>
          </div>
        </motion.div>
      </div>
    );
  }
}

export default Profile;
